import { FC, useState, useEffect } from 'react';
import tokens_1 from '../../data/tokens_1.json';
import { Formik, Field, Form } from 'formik';
import GroupField from '../GroupField';
import Accordion from '../Accordion';
import Tooltip from '../Tooltip';
import Button from '../GroupActions/Button';
import downloadObjectAsJson from '../../utils/download';
import AddNew from './AddNew';
import styles from './TokenForm.module.scss';
import { toTitleCase } from '../../utils/strings';
export interface TokenFormProps {
  initialValues: Record<string, any>;
}

const TokenForm: FC<TokenFormProps> = ({ initialValues }) => {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 0' }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values) => downloadObjectAsJson(values, 'design_tokens')}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <AddNew onClick={(k: string) => setFieldValue(k, {})} />
            {/* @ts-ignore */}
            <div className={styles.tokenForm__accordion}>
              {Object.keys(values).map((group, index) => (
                <Accordion
                  key={`token_group_${index}`}
                  title={<h4>{toTitleCase(group)}</h4>}
                  changeTrigger={Object.values(values[group]).length}
                >
                  <GroupField label='Color Tokens' name={group} valueList={values} />
                </Accordion>
              ))}
            </div>
            <Button type='submit' theme='accent' variant='outline' label='Download' />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TokenForm;
